"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx8 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["classNames", "Component", "ComponentProps", "long", "ui", "blackAndWhite", "viewBox", "classes", "effect", "autoStopTime", "animationStateInitially", "autoStopInitially"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? (additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.logo) || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? _Button["default"] : _props$Component,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$long = props["long"],
    _long = _props$long === void 0 ? false : _props$long,
    _props$ui = props.ui,
    ui = _props$ui === void 0 ? false : _props$ui,
    _props$blackAndWhite = props.blackAndWhite,
    blackAndWhite = _props$blackAndWhite === void 0 ? false : _props$blackAndWhite,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? _long ? !ui ? '0 0 140 60' : '0 0 103 60' : '0 0 50 60' : _props$viewBox,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    effect = props.effect,
    _props$autoStopTime = props.autoStopTime,
    autoStopTime = _props$autoStopTime === void 0 ? 6000 : _props$autoStopTime,
    animationStateInitially = props.animationStateInitially,
    _props$autoStopInitia = props.autoStopInitially,
    autoStopInitially = _props$autoStopInitia === void 0 ? false : _props$autoStopInitia,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== (additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.logo)) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var icon = (0, _react.useRef)();
  var animationState = (0, _react.useRef)(typeof animationStateInitially === 'number' ? animationStateInitially : -1);
  var blackAndWhiteState = (0, _react.useRef)(blackAndWhite);
  function setBlackAndWhite(value) {
    if (blackAndWhiteState.current !== value) {
      blackAndWhiteState.current = value;
      if (icon.current) {
        icon.current.setAttribute('class', (0, _clsx8["default"])(classes.icon, classNames.icon, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current)));
      }
    }
  }
  var runAnimation = animationState.current;
  function _setRunAnimation(v) {
    animationState.current = v;
    runAnimation = animationState.current;
    if (container.actions) {
      container.actions.setClassName((0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)));
    }
  }
  var timer = (0, _react.useRef)(0);
  function setRunAnimation(v) {
    var runAnimation = animationState.current;
    if (v !== runAnimation) {
      _setRunAnimation(v);
      if (v >= 0) {
        autoStop();
      }
    }
  }
  function autoStop() {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (autoStopTime) {
      timer.current = setTimeout(function () {
        clearTimeout(timer.current);
        var runAnimation = animationState.current;
        if (runAnimation >= 0) {
          setRunAnimation(-1);
        }
      }, autoStopTime);
    }
  }
  (0, _react.useEffect)(function () {
    if (autoStopInitially) {
      autoStop();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setRunAnimation: setRunAnimation,
          setBlackAndWhite: setBlackAndWhite
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setRunAnimation: function setRunAnimation() {},
            setBlackAndWhite: function setBlackAndWhite() {}
          }
        });
      }
    };
  });
  var _ComponentProps$href = ComponentProps.href,
    href = _ComponentProps$href === void 0 ? '' : _ComponentProps$href,
    _ComponentProps$onCli = ComponentProps.onClick,
    onClick = _ComponentProps$onCli === void 0 ? null : _ComponentProps$onCli;
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    Component: !(href || onClick) ? 'span' : 'a'
  }, ComponentProps, {
    effect: function effect(_ref) {
      var actions = _ref.actions;
      container.actions = actions;
    },
    defaultClassName: (0, _clsx8["default"])(classNames.logo, ComponentProps.className, classes.root, (0, _defineProperty2["default"])({}, classNames.disablePointerEvents, !(href || onClick))),
    className: (0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)),
    ref: ref,
    variant: 'text',
    size: 'none',
    ButtonBaseContentComponent: function ButtonBaseContentComponent() {
      return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
        xmlns: 'http://www.w3.org/2000/svg'
      }, rest, {
        viewBox: viewBox,
        className: (0, _clsx8["default"])(classNames.svg, rest.className)
      }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "a",
        x1: "101.69",
        y1: "29.87",
        x2: "101.69",
        y2: "17.91",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.11",
        stopColor: "#045d2c"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.25",
        stopColor: "#1b7934"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.4",
        stopColor: "#2f903a"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.57",
        stopColor: "#3ca03e"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.76",
        stopColor: "#44aa41"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#47ad42"
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "b",
        x1: "131.88",
        y1: "29.95",
        x2: "131.88",
        y2: "17.7",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "c",
        x1: "75.13",
        y1: "29.85",
        x2: "75.13",
        y2: "17.93",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "d",
        x1: "61.16",
        y1: "29.83",
        x2: "61.16",
        y2: "17.94",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "e",
        x1: "88.48",
        y1: "29.86",
        x2: "88.48",
        y2: "17.94",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "f",
        x1: "48.71",
        y1: "29.85",
        x2: "48.71",
        y2: "17.94",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "g",
        x1: "119.3",
        y1: "29.82",
        x2: "119.3",
        y2: "17.94",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "h",
        x1: "110.58",
        y1: "29.83",
        x2: "110.58",
        y2: "17.9",
        xlinkHref: "#a"
      }), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "i",
        x1: "44.49",
        y1: "46.97",
        x2: "117.79",
        y2: "46.97",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0",
        stopColor: "#47ad42"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.32",
        stopColor: "#43ab41"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.63",
        stopColor: "#38a33e"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.93",
        stopColor: "#249739"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#1f9438"
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "j",
        x1: "35.7",
        y1: "16.22",
        x2: "42.23",
        y2: "2.23",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0",
        stopColor: "#ccd626"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.04",
        stopColor: "#bad028"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.17",
        stopColor: "#89c02e"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.3",
        stopColor: "#5fb133"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.44",
        stopColor: "#3da638"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.57",
        stopColor: "#229d3b"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.71",
        stopColor: "#0f963d"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.85",
        stopColor: "#04923f"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#00913f"
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "k",
        x1: "28.34",
        y1: "32.22",
        x2: "13.75",
        y2: "56.5",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.33",
        stopColor: "#0e7333"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.42",
        stopColor: "#198136"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.61",
        stopColor: "#2b983a"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.79",
        stopColor: "#35a53d"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.94",
        stopColor: "#39aa3e"
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "l",
        x1: "16.94",
        y1: "18.24",
        x2: "15.64",
        y2: "5.86",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.2",
        stopColor: "#0a853a"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#34a93a"
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "m",
        x1: "2.4",
        y1: "23.24",
        x2: "32.89",
        y2: "23.24",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.16",
        stopColor: "#e8e21a"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.24",
        stopColor: "#dcde1c"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.38",
        stopColor: "#bed320"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.56",
        stopColor: "#8bc126"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.79",
        stopColor: "#47a830"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#008f39"
      })), /*#__PURE__*/_react["default"].createElement("clipPath", {
        id: "n"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M9.82,46.16V28.88H2.52L2.44,17.67H9.82c0-1.53,0-3,0-4.54V8.56L22.73,5.15c0,.49,0,.95,0,1.41V17.67H32.93l-.07,11.2H22.78c0,.14,0,.24,0,.35V45.94a4.58,4.58,0,0,0,.09,1.11",
        style: {
          "fill": "none"
        }
      })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
        id: "o",
        x1: "6.98",
        y1: "13.94",
        x2: "34.66",
        y2: "45.78",
        gradientUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.07",
        stopColor: "#e8e21a"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.08",
        stopColor: "#dfdf1b"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.14",
        stopColor: "#b1ce21"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.21",
        stopColor: "#86bf27"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.27",
        stopColor: "#62b22c"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.35",
        stopColor: "#44a730"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.43",
        stopColor: "#2b9e33"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.52",
        stopColor: "#189736"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.62",
        stopColor: "#0a9338"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "0.75",
        stopColor: "#029039"
      }), /*#__PURE__*/_react["default"].createElement("stop", {
        offset: "1",
        stopColor: "#008f39"
      }))), /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classes.icon, classNames.icon, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current)),
        ref: icon
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M47.39,9.27l-2.11.62c-.92.28-1.85.56-2.78.86a3.06,3.06,0,0,0-2,2.09c-.31,1-.59,1.93-.88,2.9-.2.64-.38,1.28-.6,2-.11-.35-.2-.6-.27-.85-.38-1.26-.77-2.52-1.12-3.79a3.43,3.43,0,0,0-2.51-2.5L31.29,9.49a3.91,3.91,0,0,1-.75-.3l1.94-.58c1-.31,2-.61,3-.93a2.92,2.92,0,0,0,1.94-1.94c.3-.92.58-1.85.87-2.78.19-.62.37-1.25.55-1.87,0-.1.07-.2.13-.38l.44,1.48c.29,1,.59,2,.88,2.94,0,.08.05.15.07.23a3.36,3.36,0,0,0,2.41,2.45l3.52,1,1.11.33Z",
        style: {
          "fill": "url(#j)"
        }
      }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M22.73,28.85c0,.14,0,.25,0,.35,0,5.57,0,11.14,0,16.72A5.14,5.14,0,0,0,22.78,47,2.9,2.9,0,0,0,24.41,49a4.17,4.17,0,0,0,1.59.38,9.18,9.18,0,0,0,3.85-.53l.95-.37c.95,3.06,1.9,6.1,2.87,9.18l-.36.15a21.64,21.64,0,0,1-4.41,1.13,35,35,0,0,1-3.54.34,26.26,26.26,0,0,1-4.16-.12,15.74,15.74,0,0,1-5.42-1.45,10,10,0,0,1-5.54-6.91,14.39,14.39,0,0,1-.43-3.13c0-.49,0-1,0-1.48V28.86Z",
        style: {
          "fill": "url(#k)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M9.77,17.64V8.53L22.68,5.12c0,.49,0,1,0,1.41v11.1",
        style: {
          "fill": "url(#l)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M22.74,28.84H32.82l.07-11.21H2.4l.08,11.21H22.74Z",
        style: {
          "fill": "url(#m)"
        }
      }), /*#__PURE__*/_react["default"].createElement("g", {
        style: {
          clipPath: "url(#n)"
        }
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M2.5,17.83h0a103.59,103.59,0,0,1,28,4.61c1.31.57,2.33,1.08,2.83,1.34q0,11.61-.08,23.22L23,50.92c0-1.91,0-15.44-9.21-20.54a14.79,14.79,0,0,0-3.93-1.5c-2.47,0-4.93.29-7.4.29C2.44,25.39,2.67,18.25,2.5,17.83Z",
        style: {
          "fill": "url(#o)"
        }
      })))), _long ? !ui ? /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classNames["long"], classes["long"])
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M96.66,17.92H97c1.79,0,3.58,0,5.37,0a4.63,4.63,0,0,1,3.08,1,3.37,3.37,0,0,1,1.2,2.32,3.71,3.71,0,0,1-.26,2,3.38,3.38,0,0,1-1.84,1.8l-.4.18,2.53,4.45a24.38,24.38,0,0,1-4.1.08l-2.16-4.1a2.22,2.22,0,0,0,0,.71c0,.23,0,.45,0,.68v2.7H96.66Zm3.74,3.13c0,.71,0,1.34,0,2H102l.2,0a1,1,0,0,0-.09-1.89C101.57,21.07,101,21.07,100.4,21.05Z",
        style: {
          "fill": "url(#a)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M131.9,17.7a6,6,0,0,1,4.38,1.79,5.88,5.88,0,0,1,1.72,4.1,6.07,6.07,0,0,1-.93,3.58,5.87,5.87,0,0,1-4.21,2.7A6.07,6.07,0,0,1,128,28.59a5.69,5.69,0,0,1-2.13-3.69,6.17,6.17,0,0,1,.87-4.45,5.86,5.86,0,0,1,4-2.61C131.08,17.76,131.49,17.74,131.9,17.7Zm0,8.73a2.08,2.08,0,0,0,2.2-1.66,3.56,3.56,0,0,0,0-1.86,2,2,0,0,0-1.73-1.68,2.16,2.16,0,0,0-2.66,1.7,4.32,4.32,0,0,0-.07,1.39A2.15,2.15,0,0,0,131.87,26.43Z",
        style: {
          "fill": "url(#b)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M69.34,17.93H73l0,0s0,0,0,0a.5.5,0,0,1,0,.12c0,1.54,0,3.07,0,4.63.6-.78,1.13-1.6,1.69-2.4l1.64-2.41H80.7l-4.09,5.68L81,29.82l-.42,0c-1.23,0-2.46,0-3.69,0a.6.6,0,0,1-.58-.32c-.93-1.41-1.88-2.82-2.82-4.22a1.73,1.73,0,0,0-.39-.43v4.95H69.35C69.28,29.51,69.26,18.4,69.34,17.93Z",
        style: {
          "fill": "url(#c)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M67.68,29.82h-4L63.11,28H59.2l-.6,1.79h-4L59,17.94h4.35Zm-6.48-7.7h-.09l-1,3.07H62.2Z",
        style: {
          "fill": "url(#d)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M90.66,17.94c1.44,4,2.88,7.89,4.31,11.83a27.21,27.21,0,0,1-3.94.05L90.43,28H86.52l-.59,1.76a34.69,34.69,0,0,1-4,0l4.34-11.85Zm-2.14,4.19-.08,0c-.34,1-.69,2-1,3.08h2.07Z",
        style: {
          "fill": "url(#e)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M46.79,20.91H43.7v-3h9.93a15.68,15.68,0,0,1,0,2.92,3.79,3.79,0,0,1-1,0H50.58c0,1,0,2,0,3s0,1.95,0,2.93v3a24.52,24.52,0,0,1-3.77,0Z",
        style: {
          "fill": "url(#f)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M124.3,17.94v3h-3.12v8.92h-3.77c0-.49,0-1,0-1.47V20.91h-3.1v-3Z",
        style: {
          "fill": "url(#g)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M112.4,29.83h-3.62l0,0,0,0q0-5.72,0-11.42V18a26.57,26.57,0,0,1,3.69,0C112.47,18.22,112.48,29.39,112.4,29.83Z",
        style: {
          "fill": "url(#h)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M112.75,12.9v2.8l-4.35,1.58V14.75Z",
        style: {
          "fill": "#48ad3c"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M134,12.9v2.8l-4.28,1.55a10.93,10.93,0,0,1,0-2.52Z",
        style: {
          "fill": "#47ad42"
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "44.49",
        y: "34.67",
        width: "73.3",
        height: "24.6",
        rx: "3",
        style: {
          "fill": "url(#i)"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M54.88,51.11H53.6l-1.78-2.86h-.09v3.58a13.82,13.82,0,0,1-2.62,0c-.08-.3-.09-8.25,0-8.66h1.34c.34,0,.67,0,1,0l.52.8c.69,1.13,1.37,2.26,2.06,3.38l.25.37.25-.35c.77-1.3,1.54-2.59,2.3-3.89a.58.58,0,0,1,.6-.35c.53,0,1.07,0,1.6,0h.38a1.88,1.88,0,0,0,0,.28v.08l0,7.9v.38H56.83l0-3.78-.08,0c-.35.48-.61,1-.92,1.5S55.19,50.58,54.88,51.11Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M81,51.9c-.76,0-1.5,0-2.23,0a.49.49,0,0,1-.31-.21c-.35-.4-.69-.81-1-1.22L75.5,48.23c0-.06-.12-.1-.23-.21-.07,1.32,0,2.58,0,3.86h-2.8V43.26l.3,0c.58,0,1.15,0,1.73,0a.7.7,0,0,1,.61.29c1,1.19,2,2.38,3,3.64,0-.39,0-.7,0-1V43.25H81Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M113.62,51.91h-3.17c-.2,0-.28-.14-.37-.26l-1.81-2.4c0-.07-.12-.14-.2-.24-.2.23-.41.44-.58.67a.54.54,0,0,0-.08.34c0,.48,0,1,0,1.44v.42h-2.8V43.27h2.8v3.06a2.8,2.8,0,0,0,.26-.21c.78-.86,1.57-1.71,2.34-2.58a.75.75,0,0,1,.65-.3c.76,0,1.52,0,2.28,0h.47l-1.16,1.28c-.67.74-1.35,1.47-2,2.22-.25.28-.25.29,0,.6l3.32,4.41Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M92.34,51.9H89.22c-.22,0-.31-.14-.41-.27-.43-.56-.85-1.13-1.27-1.7L86.81,49c-.19.2-.34.38-.51.55a.56.56,0,0,0-.17.47v1.86H83.32V43.29a13.75,13.75,0,0,1,2.81,0v3a3.32,3.32,0,0,0,.27-.21c.77-.85,1.55-1.7,2.31-2.56a.83.83,0,0,1,.72-.32c.73,0,1.47,0,2.2,0h.42c0,.18-.14.24-.22.33L89,46.69a1.83,1.83,0,0,1-.13.16c-.14.14-.13.26,0,.42.33.42.65.85,1,1.27Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M61.73,43.24h2.89v.45c0,1.43,0,2.86,0,4.29a3.51,3.51,0,0,0,.13.91,1.18,1.18,0,0,0,1.25.86,1.16,1.16,0,0,0,1.17-.91,5.94,5.94,0,0,0,.13-1.19c0-1.31,0-2.62,0-3.93V43.3a15.7,15.7,0,0,1,2.82,0c0,.1,0,.2,0,.3V48.2a4.48,4.48,0,0,1-.44,1.9A3.22,3.22,0,0,1,68,51.69a5.49,5.49,0,0,1-4,.09,3.38,3.38,0,0,1-2.23-2.62,5.16,5.16,0,0,1-.1-.88c0-1.59,0-3.18,0-4.77C61.72,43.43,61.73,43.36,61.73,43.24Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M97.11,42.47c.54-.65,1-1.24,1.5-1.82a.39.39,0,0,1,.27-.11h2.4l-.86.72c-.43.35-.86.71-1.3,1a.74.74,0,0,1-.4.16C98.22,42.48,97.71,42.47,97.11,42.47Z",
        style: {
          "fill": "#fff"
        }
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M99.8,43.27H96.91l-3.76,8.61h2.92c.2-.5.39-1,.58-1.48H100c.2.5.39,1,.58,1.48h3C102.3,49,101,46.12,99.8,43.27Zm-1.45,5H97.5c.22-.75.53-1.41.78-2.09h.1c.26.67.52,1.34.81,2.07Z",
        style: {
          "fill": "#fff"
        }
      }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(50, 52)",
        className: (0, _clsx8["default"])(classNames.ui, classes.ui)
      }, /*#__PURE__*/_react["default"].createElement("text", null, "UI"))) : null);
    }
  }));
});